<template>
  <b-card class="card search-view-cardsearch">
    <router-link
      :to="{
        name: 'course',
        params: {
          ...results
        }
      }"
    >
      <img
        :src="results.cover"
        :alt="results.title"
        class="card-img-top img-fluid"
      />
      <div class="card-body">
        <h5 class="card-title mt-2 text-center">{{ results.title }}</h5>
      </div>
    </router-link>
  </b-card>
</template>
<script>
export default {
  props: {
    results: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.search-view-cardsearch {
  background-color: rgba(0, 0, 0, 0.3);
  padding-bottom: 0%;
}
</style>

<script>
export default {
  props: {
    results: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.search-view-cardsearch {
  background-color: rgba(0, 0, 0, 0.3);
  padding-bottom: 10%;
}
</style>
